import {useEffect, useState} from 'react'

import {Badge, Button, Form, OverlayTrigger, Tooltip} from 'react-bootstrap'

import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'

import {useLazyQuery, useQuery} from '@apollo/client'
import Flatpickr from 'react-flatpickr'
import {Spanish} from 'flatpickr/dist/l10n/es'

import {Spinner} from '../../components/Spinner'
import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {Link} from 'react-router-dom'
// import {toast} from 'react-toastify'
import {hasPermission, includeConector, parseId} from '../../helpers'
import {GET_ALL_DESPACHOS} from '../../graphql/queries/getDespachos'
import moment from 'moment'

import type {IDataResDespachos, ListDispatchEdge} from '../../graphql/types/despachoTypes'
import {useDispatchesStore} from '../../store/dipatches'
import {IResClientsVentas} from '../../graphql/types/ventasType'
import {GET_CLIENTS_FILTER_VENTAS} from '../../graphql/queries/getVentas'
import {useNetworkStatus} from '../../hooks/useNetworkStatus'
import {toast} from 'react-toastify'
import {useGetUser} from '../../hooks/useGetUser'
import {ALL_PERMISSIONS} from '../../helpers/consts'

const ERRORS_MESSAGES = {
  NOT_NETWORK: 'Failed to fetch',
}

export const DespachosPage = () => {
  const [gqlGetAllDespachos, {data, loading, error}] = useLazyQuery<IDataResDespachos>(
    GET_ALL_DESPACHOS,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const {
    data: dataClient,
    loading: loadingClient,
    // error: errorClient,
  } = useQuery<IResClientsVentas>(GET_CLIENTS_FILTER_VENTAS)

  const {user} = useGetUser()

  const isOnline = useNetworkStatus()

  const dispatches = useDispatchesStore((s) => s.dipatches)

  const [searchTerm, setSearchTerm] = useState('')
  const [after, setAfter] = useState<string | null>(null)
  const [isPagination, setIsPagination] = useState(false)
  const [isSearch, setIsSearch] = useState(false)
  const [dataArr, setDataArr] = useState<ListDispatchEdge[]>([])
  const [datesValue, setDatesValue] = useState<{
    createdGte: undefined | string
    createdLte: undefined | string
  }>({
    createdGte: undefined,
    createdLte: undefined,
  })

  const [valueSelect, setValueSelect] = useState('')

  useEffect(() => {
    const variables: {[key: string]: string | number | Date | null} = {
      after,
    }
    if (searchTerm) {
      variables.sale_Client_Id = parseId(searchTerm)
    }
    if (datesValue.createdGte && datesValue.createdLte) {
      variables.created_Gte = new Date(datesValue.createdGte).toISOString().replace('T05', 'T00')
      variables.created_Lte = new Date(datesValue.createdLte)
        .toISOString()
        .replace('T05:00:00', 'T23:59:59')
    }
    gqlGetAllDespachos({
      variables,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [after, searchTerm, datesValue])

  useEffect(() => {
    if (error) {
      if (error.message !== ERRORS_MESSAGES.NOT_NETWORK) {
        toast.error('Error: ' + error.message)
      }
    }
  }, [error])

  useEffect(() => {
    if (!data) return
    setIsSearch(false)
    if (isPagination) {
      setDataArr((prev) => [...prev, ...data.listDispatch.edges])
      return
    }
    setDataArr(data.listDispatch.edges)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (!isOnline) return
    setAfter(null)
    if (valueSelect === '') {
      setSearchTerm('')
      setIsSearch(false)
      setIsPagination(false)
      return
    }
    setSearchTerm(valueSelect)
    setIsSearch(true)
  }, [valueSelect, isOnline])
  const searchForDates = (e: Date[]) => {
    if (e.length === 1) return

    if (e && e.length === 2) {
      setIsSearch(true)
      const createdGte = new Date(e[0]).toISOString()
      const createdLte = new Date(e[1]).toISOString()

      return setDatesValue({
        createdGte,
        createdLte,
      })
    }
    setDatesValue({
      createdGte: undefined,
      createdLte: undefined,
    })
    setAfter(null)
  }

  if (loading && !isPagination && !isSearch) {
    return (
      <div>
        <PageTitle
          breadcrumbs={[
            {
              title: 'CMR',
              path: '/',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
        >
          Lista de despachos
        </PageTitle>
        <KTCard>
          <div style={{height: '40vh'}}>
            <KTCardBody className='py-4 d-flex align-items-center justify-content-center h-100'>
              <Spinner />
            </KTCardBody>
          </div>
        </KTCard>
      </div>
    )
  }
  const canterasList = dataArr

  const permissions = user?.tokenAuth.permissions ?? ['']

  return (
    <div>
      <BreadcrumbJeisat
        title='Lista de despachos'
        breadcrumb={[
          {
            title: 'CRM',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={
          <>
            {hasPermission(permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_DESPACHO) ? (
              <Link
                className='d-flex align-items-center gap-1 btn btn-primary'
                to='/agregar-despacho'
              >
                <i className='fa-solid fa-truck-arrow-right' /> Agregar despacho
              </Link>
            ) : null}
          </>
        }
      />

      <KTCard>
        <div className='card-header border-0 pt-6 align-items-center'>
          <div className='card-title'>
            {/* begin::Search */}
            <Form.Select
              disabled={loadingClient || !isOnline}
              value={valueSelect}
              onChange={(e) => setValueSelect(e.target.value)}
            >
              <option value=''>Seleccione un cliente</option>
              {dataClient?.clientList.edges.map(({node: nodeClient}) => (
                <option key={nodeClient.id} value={nodeClient.id}>
                  {nodeClient.name}
                </option>
              ))}
            </Form.Select>
            {loading && isSearch && <Spinner size='20px' />}
            {/* end::Search */}
          </div>
          {/* begin::Card toolbar */}
          {/*  <div className='card-toolbar'>
            {/* begin::Group actions
            <UsersListToolbar />
            {/* end::Group actions 
          </div> */}
          {/* end::Card toolbar */}
          <div
            style={{
              flex: 1,
              maxWidth: '331px',
            }}
          >
            <div className='input-group'>
              <span className='input-group-text' id='basic-addon1'>
                <i className='bi bi-calendar3' />
              </span>
              <Flatpickr
                disabled={!isOnline}
                placeholder='Seleccione fecha(s)'
                className='form-control'
                onChange={(e) => searchForDates(e)}
                options={{
                  mode: 'range',
                  dateFormat: 'd F y',
                  showMonths: 2,
                  locale: Spanish,
                  position: 'auto center',
                }}
              />
            </div>
          </div>
        </div>
        <KTCardBody className='py-4'>
          <div className='table-responsive'>
            {canterasList.length > 0 || dispatches.length > 0 ? (
              <table
                id='kt_table_users'
                className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
              >
                <thead className='fw-bold'>
                  <tr className='text-start text-gray-900 fw-bold fs-7 text-uppercase gs-0'>
                    <th>Estado</th>
                    <th>Cliente</th>
                    <th>Placa</th>
                    <th>Hora de salida</th>
                    <th>Despachado por</th>
                    <th>Productos</th>
                    <th />
                  </tr>
                </thead>
                <tbody className='text-gray-700'>
                  {dispatches.map(({plate, departureTime, client, products}, idx) => (
                    <tr key={idx}>
                      <td title='Pendiente'>
                        <Badge bg='warning'>
                          <i className='bi bi-exclamation-circle text-light' />
                        </Badge>
                      </td>
                      <td className='text-uppercase'>{client.split('***')[1]}</td>
                      <td className='text-uppercase'>{plate}</td>
                      <td>
                        {departureTime
                          ? moment(departureTime).format('DD MMM [del] YY - hh:mm A')
                          : 'N/A'}
                      </td>
                      <td>Acutal despachador</td>
                      <td>
                        {products.map((pro) => (
                          <div key={pro.product}>
                            {pro.quantityDispatch} {includeConector(pro.product.split('***')[1])}
                          </div>
                        ))}
                      </td>
                      {/* <td style={{maxWidth: '130px'}} className='truncate-jeiset'>
                        {node.observations}
                      </td> */}
                      <td>
                        {/* <Link
                          className='border-0 p-0 m-0 bg-transparent me-4 hover-bg-color-dark text-secondary'
                          title='Ver'
                          to={`/despacho/${parseId(node.id)}`}
                        >
                          <i className='fa fa-eye text-primary' />
                        </Link> */}
                        {/* <button
                          className='border-0 p-0 m-0 bg-transparent hover-bg-color-dark text-secondary'
                          onClick={() => setIdCanteraEdit(node.id)}
                          title='Ver'
                        >
                          <i className='fa fa-eye' style={{color: 'inherit'}} />
                        </button> */}
                      </td>
                    </tr>
                  ))}
                  {canterasList.map(({node}) => (
                    <tr key={node.id}>
                      <td title='Guardado'>
                        {node.id && (
                          <Badge bg='success'>
                            <i className='bi bi-check-circle-fill text-light' />
                          </Badge>
                        )}
                      </td>
                      <td className='text-uppercase'>{node.sale.client.name}</td>
                      <td className='text-uppercase'>{node.plate}</td>
                      <td>
                        {node.departureDatetime
                          ? moment(node.departureDatetime).format('DD MMM [del] YY - hh:mm A')
                          : 'N/A'}
                      </td>
                      <td>{node.dispatchedBy}</td>
                      <td>
                        <div className='text-center'>
                          <OverlayTrigger
                            placement='left'
                            overlay={
                              <Tooltip id={`tooltip-$left`}>
                                {node.dispatchproductthroughSet.edges.map(({node: nodePro}) => (
                                  <p key={nodePro.id}>
                                    {nodePro.quantityDispatch} {nodePro.product.unitType} de{' '}
                                    {nodePro.product.name}
                                  </p>
                                ))}
                              </Tooltip>
                            }
                          >
                            <span className='d-flex flex-center'>
                              <span>{node.dispatchproductthroughSet.edges.length}</span>
                              <small className='ms-2 text-info cursor-pointer'>
                                <i className='bi bi-info-circle fs-4 m-0 p-0' />
                              </small>
                            </span>
                          </OverlayTrigger>
                        </div>
                      </td>
                      {/* <td style={{maxWidth: '130px'}} className='truncate-jeiset'>
                        {node.observations}
                      </td> */}
                      <td>
                        <Link
                          className='border-0 p-0 m-0 bg-transparent me-4 hover-bg-color-dark text-secondary'
                          title='Ver'
                          to={`/despacho/${parseId(node.id)}`}
                        >
                          <i className='fa fa-eye text-primary' />
                        </Link>
                        {/* <button
                          className='border-0 p-0 m-0 bg-transparent hover-bg-color-dark text-secondary'
                          onClick={() => setIdCanteraEdit(node.id)}
                          title='Ver'
                        >
                          <i className='fa fa-eye' style={{color: 'inherit'}} />
                        </button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div
                className='d-flex text-center w-100 align-items-center justify-content-center'
                style={{height: '30vh'}}
              >
                <div>No hay despachos registrados</div>
              </div>
            )}
          </div>
          {loading && isPagination && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Spinner size='24px' />
            </div>
          )}
          {data?.listDispatch.pageInfo.hasNextPage && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Button
                size='sm'
                variant='info'
                onClick={() => {
                  setIsPagination(true)
                  setAfter(data.listDispatch.pageInfo.endCursor)
                }}
              >
                Cargar más despachos
              </Button>
            </div>
          )}
          {/* {isLoading && <UsersListLoading />} */}
        </KTCardBody>
      </KTCard>
    </div>
  )
}
